import React from 'react';
import SpecialistsHero from '../components/specialists/SpecialistsHero';
import SpecialistsList from '../components/specialists/SpecialistsList';

const Specialists: React.FC = () => {
  return (
    <div className="relative bg-light">
      {/* Hero com animação e interação */}
      <SpecialistsHero />

      {/* Lista de especialistas */}
      <section id="lista-especialistas" className="py-16 md:py-20 lg:py-24 relative">
        <div className="container-custom">
          <SpecialistsList />
        </div>
      </section>
    </div>
  );
};

export default Specialists;